import Shortcode, { IShortcodeProps } from "src/libs/useful/shortcode"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, ITableRCell, ITableRow, LANDING_TYPE_CONTENT, SELECT_TYPE, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import TextEditor from "../landing-edit/text-editor"
import { __ } from "src/libs/utilities"
import updateSection from "../landing-edit/utils/updateSection" 

/* Protopia Ecosystem component */
export interface ITextBlockProps extends Omit<IShortcodeProps, "content"> {
    columns?: number
    text: string
    section: ILandingSection
    data: any // DataContent || Float || TITLE || ets... 
    editType: SELECT_TYPE
    children?: JSX.Element
    columnGap?: number
    [key:string]: any
}
const TextBlock = (props: ITextBlockProps): JSX.Element => {
    const isEdit: boolean = useLandingStore((state: ILandingStore) => state.isEdit )
    const onChange =(value: string) => {
        if(
            typeof value !== "string" ||
            props.data.text === value
        ) return 
        value = value.replace(/"((?:[^<>"]|<[^>]+>)*)"/g, "«$1»")
        const landing: ILanding = useLandingStore.getState().currentLanding
        let newSection: ILandingSection, sections: ILandingSection[],
            historyStep: IHistoryStep = { 
                type: HISTORY_TYPE.SECTION, 
                title: __("Show section"), 
                prevData: props.section,
                data: null,
            }
        switch( props.editType ) {
            case SELECT_TYPE.CONTENT: 
                newSection = {
                    ...props.section,
                    data: props.section.data.map(data => {
                        if(data.id === props.data.id) {
                            return {
                                ...data,
                                text: value
                            }
                        }
                        return data
                    })
                } 
                updateSection(  
                    newSection, 
                    {
                        ...historyStep,
                        title: __("Update Meat text"),
                        data: newSection 
                    } 
                )
                break
            case SELECT_TYPE.TITLE:
                console.log(value, props.section, props.editType, props.data )
                newSection = {
                    ...props.section,
                    title: {
                        ...props.section.title,
                        text: value
                    }
                }
                updateSection(  
                    newSection, 
                    {
                        ...historyStep,
                        title: __("Update Section's title"),
                        data: newSection 
                    } 
                )
                break
            case SELECT_TYPE.CARD_FIELD_HTML:
            case SELECT_TYPE.CARD_FIELD_TITLE: 
                console.log(value, props.editType, props.data )
                newSection = {
                    ...props.section, 
                    data: props.section.data.map(data => {
                        if( props.data.cardData && Array.isArray(data.cards) &&  data.cards.find(crd => crd.id === props.data.cardData.id) ) {
                            const cards = data.cards.map(( card: any, i: number ) => {
                                if( i === props.data.cardData.i ) {                                    
                                    const newCard = !!props.data.field.pseudonym 
                                    ?
                                    {
                                        ...card,
                                        [ props.data.field.pseudonym  ] : {
                                            ...card[ props.data.field.pseudonym ],
                                            data: value
                                        }
                                    }
                                    :
                                    {
                                        ...card,
                                        value: card.value.map((v: any, i: number) => {
                                            if(i === props.data.i) {
                                                return {...v, data: value}
                                            }
                                            return v
                                        })
                                    }
                                    console.log( newCard, props.data.field.pseudonym, props.data.i )
                                    
                                    return newCard
                                }
                                return card
                            })
                            return { ...data, cards }
                        }
                        return data
                    }) 
                }
                // console.log( props.data.cardData.id, props.data.i, props.data.field.pseudonym, newSection )
                
                
                sections = landing.sections.map(section => {
                    if( section.id === newSection.id ) {
                        return newSection
                    }
                    return section
                }) 
                
                if( JSON.stringify( sections ) === JSON.stringify( landing.sections ) )
                    break
                
                
                updateSection(  
                    newSection, 
                    {
                        ...historyStep,
                        title: __("Update Card's text"),
                        data: newSection 
                    } 
                )
                break
            case SELECT_TYPE.TABLE_TD:
                // console.log(value, props.editType, props.data )
                newSection = {
                    ...props.section, 
                    data: props.section.data.map(meat => {
                        if( meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.data.table?.id ) {
                            return {
                                ...meat,
                                data: (meat as TableContent).data.map((row: ITableRow) => {
                                    console.log( props.data.row, row ) 
                                    if( props.data.row.id === row.id) {
                                        return {
                                            ...row,
                                            cells: row.cells.map((cell: ITableRCell, i: number) => {
                                                if(props.data.cell.id === cell.id) {
                                                    return {
                                                        ...cell,
                                                        text: value
                                                    }
                                                }
                                                return cell
                                            })
                                        }
                                    }
                                    return row
                                }) 
                            }
                        }
                        return meat
                    }) 
                }
                updateSection(  
                    newSection, 
                    {
                        ...historyStep,
                        title: __("Update table cell text"),
                        data: newSection 
                    } 
                )
                break
            case SELECT_TYPE.TABLE_THREAD:
                // console.log(value, props.editType, props.data )
                newSection = {
                    ...props.section, 
                    data: props.section.data.map(meat => {
                        if( meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.data.primitive?.id ) {
                            return {
                                ...meat,
                                threads: {
                                    ...(meat as TableContent).threads,
                                    cells: (meat as TableContent).threads.cells.map((cell, i) => {
                                        // console.log( props.data.th.id, cell.id)
                                        if(props.data.th.id === cell.id) {  
                                            return {
                                                ...cell,
                                                text: value
                                            }
                                        }
                                        return cell
                                    })
                                }
                            }
                        }
                        return meat
                    }) 
                }
                updateSection(  
                    newSection, 
                    {
                        ...historyStep,
                        title: __("Update table thread cell text"),
                        data: newSection 
                    } 
                )
                break
        }
    }
    return isEdit
        ?
        <TextEditor onChange={ () => {} }>
            <> 
                { props.children }
                <Shortcode 
                    { ...props }
                    content={ props.text } 
                    className={ `columns-${ props.columns} ${props.className} user-select-all` }
                    style={{ ...props.style, columnGap: props.columnGap || 20 }}
                    contentEditable
                    onClick={ onChange }
                />
            </>
        </TextEditor>
        :
        <>
            { props.children }
            <Shortcode 
                { ...props }
                content={ props.text } 
                className={ `columns-${ props.columns} ${ props.className }` }
                style={{ ...props.style, columnGap: props.columnGap || 20 }}
                contentEditable={ false }
            />
        </>
}
export default TextBlock